var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "filters",
      attrs: { autocomplete: "off", "accept-charset": "UTF-8" }
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "scroll", value: "stories" }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter filter--city" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.postcode,
                expression: "postcode"
              }
            ],
            attrs: { type: "hidden", name: "postcode" },
            domProps: { value: _vm.postcode },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.postcode = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.stad,
                expression: "stad"
              }
            ],
            attrs: { type: "hidden", name: "stad" },
            domProps: { value: _vm.stad },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.stad = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "story-filter-city" } }, [
            _vm._v("Gemeente begraafplaats")
          ]),
          _vm._v(" "),
          _c(
            "v-select",
            {
              attrs: {
                value: _vm.city,
                options: _vm.cityOptions,
                id: "story-filter-city",
                placeholder: "Postcode en stad"
              },
              on: { input: _vm.setCity }
            },
            [
              _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
                _vm._v("Postcode of stad niet gevonden!")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(3)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter" }, [
      _c("label", { attrs: { for: "story-filter-search" } }, [
        _vm._v("Zoekterm")
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "text",
          id: "story-filter-search",
          name: "zoek",
          placeholder: "Zoekterm"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter" }, [
      _c("label", { attrs: { for: "story-filter-firstName" } }, [
        _vm._v("Voornaam")
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "text",
          id: "story-filter-firstName",
          name: "voornaam",
          placeholder: "Marie-Jeanne"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter" }, [
      _c("label", { attrs: { for: "story-filter-lastname" } }, [
        _vm._v("Familienaam")
      ]),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "text",
          id: "story-filter-lastname",
          name: "familienaam",
          placeholder: "Boels"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filters__submit" }, [
      _c("input", {
        staticClass: "btn btn--green",
        attrs: { type: "submit", value: "Zoek" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }